var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5939_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 106.667V53.3333H96.5V58.6666C100.233 58.6666 103.807 59.2 107.167 60.2133V53.3333C107.167 47.4666 102.367 42.6666 96.5 42.6666H91.1667V32C91.1667 17.28 79.22 5.33331 64.5 5.33331C49.78 5.33331 37.8333 17.28 37.8333 32V42.6666H32.5C26.6333 42.6666 21.8333 47.4666 21.8333 53.3333V106.667C21.8333 112.533 26.6333 117.333 32.5 117.333H65.8867C63.6467 114.133 61.8867 110.507 60.7133 106.667H32.5ZM48.5 32C48.5 23.1466 55.6467 16 64.5 16C73.3533 16 80.5 23.1466 80.5 32V42.6666H48.5V32Z",
    fill: "#134044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5 69.3333C81.78 69.3333 69.8333 81.28 69.8333 96C69.8333 110.72 81.78 122.667 96.5 122.667C111.22 122.667 123.167 110.72 123.167 96C123.167 81.28 111.22 69.3333 96.5 69.3333ZM96.5 80C100.927 80 104.5 83.5733 104.5 88C104.5 92.4266 100.927 96 96.5 96C92.0733 96 88.5 92.4266 88.5 88C88.5 83.5733 92.0733 80 96.5 80ZM96.5 112C91.0067 112 86.1533 109.227 83.2733 104.96C87.1667 102.72 91.6467 101.333 96.5 101.333C101.353 101.333 105.833 102.72 109.727 104.96C106.847 109.227 101.993 112 96.5 112Z",
    fill: "#134044"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5939_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.bea31ecfdfa6d637e115847559d30de4.svg";
export { ForwardRef as ReactComponent };